import { render, staticRenderFns } from "./changeCamera.vue?vue&type=template&id=3b0c9bc5&scoped=true"
import script from "./changeCamera.vue?vue&type=script&lang=js"
export * from "./changeCamera.vue?vue&type=script&lang=js"
import style0 from "./changeCamera.vue?vue&type=style&index=0&id=3b0c9bc5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0c9bc5",
  null
  
)

export default component.exports